import { useMemo } from "react";

export function useDomain(): string | null {
	return useMemo(() => {
		if (typeof window === "undefined") return null;
		const origin = window.location.origin;
		return origin.replace("http://", "").replace("https://", "");
	}, []);
}
